import Marionette from "backbone.marionette";
import { EventSummaryDemographicsBreakdownItemView } from "./EventSummaryDemographicsBreakdownItemView";

export const EventSummaryDemographicsBreakdownView = Marionette.CollectionView.extend({
    tagName: 'span',

    childView: EventSummaryDemographicsBreakdownItemView,

    filter(demographic) {
        return demographic.get("quantity") > 0;
    }
});


// WEBPACK FOOTER //
// ./src/js/view/components/EventSummary/EventSummaryDemographicsBreakdownView.js